import { BaseModel } from "./base.model";

export class SelectListItem extends BaseModel {

    //#region Fields

    name: string;
    code: string;
    other: string;
    text?: string;
    value?: string;
    Selected?: boolean;
    isKisnaStore?:boolean;
    referenseId?:number;

    //#endregion

    //#region Constructor

    constructor(id: number = 0, name: string = '', code: string = '', other: string = '') {
        super();
        this.id = id;
        this.name = name;
        this.code = code;
        this.other = other;
    }

    //#endregion

    //#region Methods

    static getDefaultSelectItem(): SelectListItem {

        let languageId = 1;
        const languageTextMap: { [key: number]: { text: string, value: string } } = {
            1: { text: "Select All", value: "0" },
            2: { text: "Selecteer alle", value: "0" },
        };
        const defaultLanguageText = languageTextMap[languageId] || { text: "Default text", value: "0" };
        let itemObject = new SelectListItem();
        itemObject.text = defaultLanguageText.text;
        itemObject.value = defaultLanguageText.value;
        return itemObject;
    }

    //#endregion

}
